import { render, staticRenderFns } from "./TodosOsDados.vue?vue&type=template&id=466c44cd&scoped=true"
import script from "./TodosOsDados.vue?vue&type=script&lang=js"
export * from "./TodosOsDados.vue?vue&type=script&lang=js"
import style1 from "./TodosOsDados.vue?vue&type=style&index=1&id=466c44cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466c44cd",
  null
  
)

export default component.exports